module.exports = __webpack_public_path__ + "img/tempo-logo.25228323.svg";